import { expressionDefinitionApi, formsExpressionDefinitionApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const ROLE_BASED_SIGNING_ACTION_TYPE = createNamedActions('roleBasedSigning', {
  GET_ROLE_BASED_SIGNING_SCHEMA: 'GET_ROLE_BASED_SIGNING_SCHEMA',
});

export const getRoleBasedSigningSchema = catchAsyncActionError(() => async (dispatch, getState) => {
  const isFormsConsolidationEnabled = selectFeatureFlagByKey(FeatureFlag.FormsConsolidationEnabled)(
    getState(),
  );

  const { data } = isFormsConsolidationEnabled
    ? await formsExpressionDefinitionApi.getRoleBasedSigningExpressionDefinition()
    : await expressionDefinitionApi.getRoleBasedSigningExpressionDefinition();

  return dispatch({
    type: ROLE_BASED_SIGNING_ACTION_TYPE.GET_ROLE_BASED_SIGNING_SCHEMA,
    payload: data,
  });
});
